import React, {useState} from 'react'
import EditUserPopup from './EditUserPopup'
import {Icon} from "antd"

function EditUser(props) {
    const [isOpen, setIsOpen] = useState(false)

    const _showModal = () => {
        setIsOpen(true)
    }

    const _closeModal = () => {
        setIsOpen(false)
    }

    return (
        <div className="NewUser">
            <div className="text-primary cursor-pointer" onClick={_showModal}>
                <Icon type="edit" />
            </div>

            {
                isOpen && <EditUserPopup {...props} isOpen={isOpen} onClose={_closeModal}/>
            }
        </div>
    )
}

export default EditUser
